import { Flex, Spin } from 'antd'

import { LoadingOutlined } from '@ant-design/icons'

const flexStyle: React.CSSProperties = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    background: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 22
}

const PageLoader = () => {
    return (
        <Flex style={flexStyle}>
            <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
        </Flex>
    )
}

export default PageLoader
